import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import { Spacing20 } from 'autogen/design-tokens/tokens';
import { useRegime } from './Regime';
import RegimeCardHorizontal from './RegimeCardHorizontal';

const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Spacing20};
    width: 100%;
`;

export default function RegimeList({ children }: { children?: ReactNode }) {
    const { productEntries } = useRegime();

    return (
        <List>
            {children}
            {productEntries.map((product) => (
                <RegimeCardHorizontal product={product} key={product.product.id} />
            ))}
        </List>
    );
}
